module.exports = __webpack_public_path__ + "static/media/successotoavatar.f298d4ee.png";